import React, { Component } from 'react';
import {
    Box,
    Card,
    CardContent,
    Typography,
    TextField,
    Tooltip,
    Grid,
    Chip,
    Switch,
    MenuItem,
    Select,
    FormControl,
    Button
} from '@mui/material';

import {
    Code as CodeIcon,
    Security as SecurityIcon,
    WarningAmber as WarningIcon,
    Search as SearchIcon,
    HelpOutline as HelpOutlineIcon
} from '@mui/icons-material';
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
import { toast } from 'react-toastify';
class AdvancedSeoSettings extends Component {
    constructor(props) {
        super(props);
        this.state = {
            metaTitle: "",
            metaDescription: "",
            keywords: "",
            shareImage: "",
            facebookPixelId: "",
            tiktokPixelId: "",
            googleAnalyticsId: "",
            googleTagManagerId: "",
            maintenanceMode: false,
            catalogPassword: "",
            timezone: "Brasília (GMT-3)"
        };
    }

    componentDidMount() {
        const { data } = this.props;
        if (data) {
            this.setState(data);
        }
    }

    handleInputChange = (event) => {
        const { name, value } = event.target;
        this.setState({ [name]: value });
    };


    handleToggleChange = (event) => {
        const { name, checked } = event.target;
        this.setState({ [name]: checked });
    };
    render() {
        const { metaTitle, metaDescription, keywords, shareImage, facebookPixelId,
            tiktokPixelId,
            googleAnalyticsId,
            googleTagManagerId,
            maintenanceMode,
            catalogPassword,
            timezone } = this.state;

        return (
            <Box sx={{ bgcolor: '#fff', minHeight: '100vh', p: 0, fontFamily: 'sans-serif' }}>

                {/* Cabeçalho Principal */}
                <Box mb={4}>
                    <Typography variant="h5" sx={{ fontWeight: 'bold', color: '#1a1a1a' }}>
                        Avançado
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                        Domínio, SEO e integrações
                    </Typography>
                </Box>

                {/* Card Principal de SEO */}
                <Card variant="outlined" sx={{ borderRadius: 3, p: 1, bgcolor: '#ffffff' }}>
                    <CardContent>

                        {/* Subtítulo com Ícone de Lupa */}
                        <Box display="flex" alignItems="center" gap={1} mb={3}>
                            <SearchIcon sx={{ color: '#5f6368', fontSize: 20 }} />
                            <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: '#1a1a1a' }}>
                                SEO
                            </Typography>
                        </Box>

                        {/* Container do Formulário Espaçado */}
                        <Box component="form" noValidate autoComplete="off" sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>

                            {/* Campo: Título (Meta Title) */}
                            <Box>
                                <Typography variant="body2" sx={{ fontWeight: 'bold', mb: 1, color: '#1a1a1a' }}>
                                    Título (Meta Title)
                                </Typography>
                                <TextField
                                    fullWidth
                                    name="metaTitle"
                                    value={metaTitle}
                                    onChange={this.handleInputChange}
                                    variant="outlined"
                                    size="small"
                                    inputProps={{ maxLength: 60 }}
                                    sx={{
                                        '& .MuiOutlinedInput-root': {
                                            borderRadius: 2,
                                            bgcolor: '#fafafa',
                                        }
                                    }}
                                />
                                <Typography variant="caption" color="textSecondary" sx={{ mt: 0.5, display: 'block' }}>
                                    {metaTitle.length}/60 caracteres
                                </Typography>
                            </Box>

                            {/* Campo: Descrição (Meta Description) */}
                            <Box>
                                <Typography variant="body2" sx={{ fontWeight: 'bold', mb: 1, color: '#1a1a1a' }}>
                                    Descrição (Meta Description)
                                </Typography>
                                <TextField
                                    fullWidth
                                    name="metaDescription"
                                    value={metaDescription}
                                    onChange={this.handleInputChange}
                                    variant="outlined"
                                    multiline
                                    rows={3}
                                    inputProps={{ maxLength: 160 }}
                                    sx={{
                                        '& .MuiOutlinedInput-root': {
                                            borderRadius: 2,
                                            bgcolor: '#fafafa',
                                        }
                                    }}
                                />
                                <Typography variant="caption" color="textSecondary" sx={{ mt: 0.5, display: 'block' }}>
                                    {metaDescription.length}/160 caracteres
                                </Typography>
                            </Box>

                            {/* Campo: Palavras-chave */}
                            <Box>
                                <Typography variant="body2" sx={{ fontWeight: 'bold', mb: 1, color: '#1a1a1a' }}>
                                    Palavras-chave
                                </Typography>
                                <TextField
                                    fullWidth
                                    name="keywords"
                                    value={keywords}
                                    onChange={this.handleInputChange}
                                    variant="outlined"
                                    size="small"
                                    sx={{
                                        '& .MuiOutlinedInput-root': {
                                            borderRadius: 2,
                                            bgcolor: '#fafafa',
                                        }
                                    }}
                                />
                                <Typography variant="caption" color="textSecondary" sx={{ mt: 0.5, display: 'block' }}>
                                    Separe as palavras-chave por vírgula
                                </Typography>
                            </Box>

                            {/* Campo: Imagem de Compartilhamento */}
                            <Box>
                                <Box display="flex" alignItems="center" gap={0.5} mb={1}>
                                    <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#1a1a1a' }}>
                                        Imagem de Compartilhamento
                                    </Typography>
                                    <Tooltip title="Esta imagem aparece quando seu link é compartilhado nas redes sociais." placement="right" arrow>
                                        <HelpOutlineIcon sx={{ fontSize: 16, color: '#9ca3af', cursor: 'pointer' }} />
                                    </Tooltip>
                                </Box>
                                <TextField
                                    fullWidth
                                    name="shareImage"
                                    value={shareImage}
                                    onChange={this.handleInputChange}
                                    variant="outlined"
                                    size="small"
                                    sx={{
                                        '& .MuiOutlinedInput-root': {
                                            borderRadius: 2,
                                            bgcolor: '#fafafa',
                                        }
                                    }}
                                />
                                <Typography variant="caption" color="textSecondary" sx={{ mt: 0.5, display: 'block' }}>
                                    Cole a URL de uma imagem. Se vazio, usa o logo da loja.
                                </Typography>
                            </Box>

                        </Box>

                    </CardContent>
                </Card>

                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4, mt: 4 }}>

                    {/* ================= SECÇÃO: INTEGRAÇÕES ================= */}
                    <Card variant="outlined" sx={{ borderRadius: 3, p: 1, bgcolor: '#ffffff' }}>
                        <CardContent>

                            {/* Título da Secção com Badge Pro */}
                            <Box display="flex" alignItems="center" gap={1} mb={3}>
                                <CodeIcon sx={{ color: '#5f6368', fontSize: 20 }} />
                                <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: '#1a1a1a' }}>
                                    Integrações
                                </Typography>
                                <Chip
                                    label="Pro"
                                    size="small"
                                    sx={{
                                        bgcolor: '#f5f3ff',
                                        color: '#7c3aed',
                                        fontWeight: 'bold',
                                        height: 20,
                                        fontSize: '0.75rem',
                                        border: '1px solid #e0d7ff'
                                    }}
                                />
                            </Box>

                            {/* Grid de Inputs de Pixels/Analytics */}
                            <Grid container spacing={3} mb={2}>
                                <Grid item xs={12} sm={6}>
                                    <Typography variant="body2" sx={{ fontWeight: 'bold', mb: 1, color: '#1a1a1a' }}>
                                        Facebook Pixel ID
                                    </Typography>
                                    <TextField
                                        fullWidth
                                        name="facebookPixelId"
                                        placeholder='1234567890'
                                        value={facebookPixelId}
                                        onChange={this.handleInputChange}
                                        variant="outlined"
                                        size="small"
                                        sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2, bgcolor: '#fafafa' } }}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={6}>
                                    <Typography variant="body2" sx={{ fontWeight: 'bold', mb: 1, color: '#1a1a1a' }}>
                                        TikTok Pixel ID
                                    </Typography>
                                    <TextField
                                        fullWidth
                                        name="tiktokPixelId"
                                        placeholder='ABC123DEF456'
                                        value={tiktokPixelId}
                                        onChange={this.handleInputChange}
                                        variant="outlined"
                                        size="small"
                                        sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2, bgcolor: '#fafafa' } }}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={6}>
                                    <Typography variant="body2" sx={{ fontWeight: 'bold', mb: 1, color: '#1a1a1a' }}>
                                        Google Analytics ID
                                    </Typography>
                                    <TextField
                                        fullWidth
                                        name="googleAnalyticsId"
                                        placeholder='G-XXXXXXXXXX'
                                        value={googleAnalyticsId}
                                        onChange={this.handleInputChange}
                                        variant="outlined"
                                        size="small"
                                        sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2, bgcolor: '#fafafa' } }}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={6}>
                                    <Typography variant="body2" sx={{ fontWeight: 'bold', mb: 1, color: '#1a1a1a' }}>
                                        Google Tag Manager ID
                                    </Typography>
                                    <TextField
                                        fullWidth
                                        name="googleTagManagerId"
                                        placeholder='GTM-XXXXXXX'
                                        value={googleTagManagerId}
                                        onChange={this.handleInputChange}
                                        variant="outlined"
                                        size="small"
                                        sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2, bgcolor: '#fafafa' } }}
                                    />
                                </Grid>
                            </Grid>

                            <Typography variant="caption" color="textSecondary">
                                Os pixels de rastreamento ajudam a medir conversões e criar públicos para suas campanhas de anúncios.
                            </Typography>
                        </CardContent>
                    </Card>

                    {/* ================= SECÇÃO: SEGURANÇA ================= */}
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>

                        {/* Título da Secção Segurança */}
                        <Box display="flex" alignItems="center" gap={1}>
                            <SecurityIcon sx={{ color: '#5f6368', fontSize: 20 }} />
                            <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: '#1a1a1a' }}>
                                Segurança
                            </Typography>
                        </Box>

                        {/* Bloco: Modo Manutenção */}
                        <Box
                            display="flex"
                            justifyContent="space-between"
                            alignItems="center"
                            sx={{ border: '1px solid #e5e7eb', p: 2, borderRadius: 3, bgcolor: '#ffffff' }}
                        >
                            <Box display="flex" alignItems="center" gap={2}>
                                <Box
                                    sx={{
                                        bgcolor: '#f9fafb',
                                        border: '1px solid #e5e7eb',
                                        borderRadius: 2,
                                        p: 1,
                                        display: 'flex',
                                        alignItems: 'center'
                                    }}
                                >
                                    <WarningIcon sx={{ color: '#9ca3af' }} />
                                </Box>
                                <Box>
                                    <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#1a1a1a' }}>
                                        Modo manutenção
                                    </Typography>
                                    <Typography variant="caption" color="textSecondary">
                                        {maintenanceMode ? "O catálogo está oculto para visitantes" : "Catálogo está visível para todos"}
                                    </Typography>
                                </Box>
                            </Box>
                            <Switch
                                name="maintenanceMode"
                                checked={maintenanceMode}
                                onChange={this.handleToggleChange}
                                color="primary"
                                sx={{
                                    '& .MuiSwitch-switchBase.Mui-checked': { color: '#7c3aed' },
                                    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { bgcolor: '#7c3aed' }
                                }}
                            />
                        </Box>

                        {/* Campo: Senha do Catálogo */}
                        <Box>
                            <Typography variant="body2" sx={{ fontWeight: 'bold', mb: 1, color: '#1a1a1a' }}>
                                Senha do catálogo
                            </Typography>
                            <TextField
                                fullWidth
                                name="catalogPassword"
                                value={catalogPassword}
                                onChange={this.handleInputChange}
                                placeholder="Deixe vazio para catálogo público"
                                variant="outlined"
                                size="small"
                                sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2, bgcolor: '#fafafa' } }}
                            />
                            <Typography variant="caption" color="textSecondary" sx={{ mt: 0.5, display: 'block' }}>
                                Se definida, visitantes precisarão digitar a senha para acessar
                            </Typography>
                        </Box>

                        {/* Campo: Fuso Horário */}
                        <Box>
                            <Typography variant="body2" sx={{ fontWeight: 'bold', mb: 1, color: '#1a1a1a' }}>
                                Fuso Horário
                            </Typography>
                            <FormControl fullWidth size="small">
                                <Select
                                    name="timezone"
                                    value={timezone}
                                    onChange={this.handleInputChange}
                                    sx={{ borderRadius: 2, bgcolor: '#fafafa' }}
                                >
                                    <MenuItem value="Brasília (GMT-3)">Brasília (GMT-3)</MenuItem>
                                    <MenuItem value="Lisboa (GMT+1)">Lisboa (GMT+1)</MenuItem>
                                    <MenuItem value="Azores (GMT-1)">Açores (GMT-1)</MenuItem>
                                    <MenuItem value="London (GMT+0)">Londres (GMT+0)</MenuItem>
                                </Select>
                            </FormControl>
                        </Box>

                    </Box>
                </Box>
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        alignItems: 'flex-end',
                        mt: 4,
                        pt: 2,
                        borderTop: '1px solid #eee'
                    }}
                >


                    <Button

                        variant="contained"
                        startIcon={<SaveOutlinedIcon />}
                        onClick={() => {

                            fetch(`${process.env.REACT_APP_API_URL}/settings/advanced`, {
                                method: 'POST',
                                credentials: 'include',
                                headers: {
                                    'Content-Type': 'application/json',
                                },
                                body: JSON.stringify(this.state),
                            })
                                .then(response => {
                                    if (response.ok) {
                                        toast.success('Configurações atualizadas com sucesso!');
                                    } else {
                                        toast.error('Erro ao atualizar as configurações.');
                                    }
                                })
                                .catch(error => {
                                    console.error('Erro ao atualizar as configurações:', error);
                                });
                        }}
                        sx={{
                            textTransform: 'none',
                            borderRadius: '8px',
                            bgcolor: '#6200ee',
                            px: 4,
                            '&:hover': { bgcolor: '#4a00b8' }
                        }}
                    >
                        Salvar
                    </Button>
                </Box>

            </Box>
        );
    }
}

export default AdvancedSeoSettings;